module.exports = __webpack_public_path__ + "media/eat3.28678600.mp4";